import React, { useEffect, useState } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Offsidebar from './Offsidebar';
import Footer from './Footer';
import BaseRun from './Base.run';
import UserProfile from '../Common/UserProfile';
import { initialize } from '../Api/EventsStream';
import { isSessionEnding } from '../Api/authSession';
import { store } from '../../store/store';

const messages = defineMessages({
  button_cancel: {
    id: 'Base.button.cancel',
    defaultMessage: 'Cancel'
  },
  grid_noData: {
    id: 'Base.grid.noData',
    defaultMessage: 'No data'
  },
  grid_applyFilters: {
    id: 'Base.grid.applyFilters',
    defaultMessage: 'Select one or more filters and click on Filter Data to display info.'
  },
  grid_sort: {
    id: 'Base.grid.sort',
    defaultMessage: 'Sort'
  },
  grid_filter: {
    id: 'Base.grid.filter',
    defaultMessage: 'Filter...'
  },
  grid_search: {
    id: 'Base.grid.search',
    defaultMessage: 'Search...'
  },
  grid_groupByCol: {
    id: 'Base.grid.groupByCol',
    defaultMessage: 'Drag a column here to group by'
  },
  grid_paging_showAll: {
    id: 'Base.grid.paging_showAll',
    defaultMessage: 'Show all'
  },
  grid_paging_rowsPerPage: {
    id: 'Base.grid.paging_rowsPerPage',
    defaultMessage: 'Rows per page'
  },
  grid_paging_info: {
    id: 'Base.grid.paging_info',
    defaultMessage: '{from}-{to} of {count}'
  },
  grid_export: {
    id: 'Base.grid.export',
    defaultMessage: 'Export'
  },
  grid_exportAll: {
    id: 'Base.grid.exportAll',
    defaultMessage: 'Export to Spreadsheet'
  },
  grid_exportSelected: {
    id: 'Base.grid.exportSelected',
    defaultMessage: 'Export selected to Spreadsheet'
  },
  grid_average: {
    id: 'Base.grid.average',
    defaultMessage: 'Average'
  },
  grid_sum: {
    id: 'Base.grid.sum',
    defaultMessage: 'Sum'
  },
  grid_count: {
    id: 'Base.grid.count',
    defaultMessage: 'Count'
  },
  info_mobilePhoneAvailable: {
    id: 'Base.info_mobilePhoneAvailable',
    defaultMessage: 'Update contact information'
  },
  info_mobilePhoneAvailableMsg: {
    id: 'Base.info_mobilePhoneAvailableMsg',
    defaultMessage:
      'Please update your contact information (mobile number) so we can reach you regarding the selection process when necessary.'
  },
  info_addPhoneNumber: {
    id: 'Base.button.info_addPhoneNumber',
    defaultMessage: 'Update now'
  },
  info_remindLater: {
    id: 'Base.button.info_remindLater',
    defaultMessage: 'Later'
  }
});

function Base({ children, intl, history }) {
  const [showedNotification, setShowedNotification] = useState(false);
  const [userLang, setUserLang] = useState('');

  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    async function load() {
      if (!UserProfile.hasLogged()) return;

      try {
        await initialize();

        const account = store.getState().accountInfo && store.getState().accountInfo.accountInfo;
        const loggedUser = store.getState().user && store.getState().user.user;

        BaseRun(
          UserProfile.getId(),
          UserProfile.getName(),
          UserProfile.getEmail(),
          UserProfile.getIdentifierHash(),
          account && account.unique_name,
          loggedUser && loggedUser.phone_mobile,
          loggedUser && loggedUser.phone_country
        );
      } catch (error) {
        console.error('Base bootstrap failed', error);
      }
    }
    load();
  }, []);

  useEffect(() => {
    function loadUser() {
      setUserLang(user.language);
    }
    loadUser();
  }, [user]);

  // Separate effect for phone notification that runs after user is loaded
  useEffect(() => {
    if (!showedNotification && user && user.username && !user.phone_mobile) {
      // Check if we should show the phone notification
      const showPhoneNotification = sessionStorage.getItem('showPhoneNotification');
      if (showPhoneNotification === 'true' && !isSessionEnding()) {
        // Remove the flag immediately to prevent showing again
        sessionStorage.removeItem('showPhoneNotification');
        setShowedNotification(true);

        // Show the notification after everything is loaded
        setTimeout(() => {
          if (isSessionEnding()) return;
          window
            .swal({
              type: 'info',
              title: intl.formatMessage({
                id: 'Base.info_mobilePhoneAvailable'
              }),
              text: intl.formatMessage({
                id: 'Base.info_mobilePhoneAvailableMsg'
              }),
              showCancelButton: true,
              buttons: {
                cancel: {
                  text: intl.formatMessage({
                    id: 'Base.button.info_remindLater'
                  }),
                  value: null,
                  visible: true,
                  className: '',
                  closeModal: true
                },
                confirm: {
                  text: intl.formatMessage({
                    id: 'Base.button.info_addPhoneNumber'
                  }),
                  value: true,
                  visible: true,
                  className: '',
                  closeModal: true
                }
              }
            })
            .then((isConfirm) => {
              if (isConfirm) {
                // Redirect to settings page
                history.push('/settings');
              }
            });
        }, 1500);
      }
    }
  }, [user, showedNotification, intl, history]);

  return (
    <div className="wrapper">
      <Header />
      <Sidebar lang={userLang} />
      <Offsidebar />
      <section className="section-container">{children}</section>
      <Footer />
    </div>
  );
}

export default withRouter(injectIntl(Base));
